import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home.js";
import Header from "../Component/Header.js";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import {
  Backdrop,
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "moment/locale/th";
import Skeleton from "react-loading-skeleton";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import CryptoJS from "crypto-js";

import ScrollableChannelPay from "./ScrollableChannelPay.js";
import successGif from "../../images/successGiff.gif";

import {
  getPolicyInformationAPI,
  getCheckCreditCard,
} from "../PolicyList/PolicyListService/policyListService";
import { requestOtpAPI } from "../changePay/changePayService/changePayService";
import { updatePersonalChangePaymentChannelAPI } from "../Personal/PersonalService/personalService.js";
import ContactModal from "../Component/ContactModal";

const ChangeChannelPay = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [LoadingContent, setLoadingContent] = useState(false);
  const [dataPolicies, setDataPolicies] = useState([]);

  // เลือกหลายกรมธรรม์
  const [selectedPolicyNos, setSelectedPolicyNos] = useState([]); // ['00323467', ...]
  // ช่องทางใหม่ของแต่ละกรมธรรม์
  const [selections, setSelections] = useState({}); // { [policyNo]: 'account'|'credit'|'counter' }
  // สถานะการผูกบัตรต่อกรมธรรม์ (true = ยังไม่ผูก ต้อง disable)
  const [creditMap, setCreditMap] = useState({}); // { [policyNo]: boolean }

  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [openContactModal, setOpenContactModal] = useState(false);

  const insureIdCard = localStorage.getItem("customer_id") || "";
  const fullName = `${localStorage.getItem("first_name") || ""} ${
    localStorage.getItem("last_name") || ""
  }`;

  const allOptions = [
    { value: "account", label: "หักจากบัญชีออมทรัพย์" },
    { value: "credit", label: "หักผ่านบัตรเครดิตอัตโนมัติ" },
    { value: "counter", label: "ชำระผ่านเคาน์เตอร์ธนาคาร" },
  ];

  // ===== utils =====
  const decrypt = (cipher) => {
    const bytes = CryptoJS.AES.decrypt(
      cipher,
      process.env.REACT_APP_ENCRYPT_DATA
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  };
  const notifySuccess = (m) => toast.success(m, { position: "top-center" });
  const notifyError = (m) => toast.error(m, { position: "top-center" });

  // แนวทางตัวเลือกที่อนุญาตจาก "ช่องทางปัจจุบัน"
  const getAvailableOptions = (currentLabel) => {
    const mapValue = (label) => {
      if (label === "หักจากบัญชีออมทรัพย์") return "account";
      if (label === "หักผ่านบัตรเครดิตอัตโนมัติ") return "credit";
      if (label === "ชำระผ่านเคาน์เตอร์ธนาคาร") return "counter";
      return "account";
    };
    const cur = mapValue(currentLabel);
    if (cur === "account")
      return allOptions.filter((o) => o.value !== "account"); // credit, counter
    if (cur === "credit")
      return allOptions.filter((o) => o.value === "counter"); // counter only
    if (cur === "counter")
      return allOptions.filter((o) => o.value === "credit"); // credit only
    return allOptions;
  };

  // โหลดสถานะเครดิตต่อกรมธรรม์ (cache)
  const ensureCreditStatus = async (policyNo) => {
    if (creditMap[policyNo] !== undefined) return;
    const result = await getCheckCreditCard(policyNo, decrypt(insureIdCard));
    setCreditMap((m) => ({ ...m, [policyNo]: !result.status }));
  };

  // toggle เลือก/ไม่เลือกกรมธรรม์
  const handleTogglePolicy = (policyNo, checked) => {
    setSelectedPolicyNos((arr) =>
      checked
        ? [...new Set([...arr, policyNo])]
        : arr.filter((p) => p !== policyNo)
    );
  };

  // เปลี่ยนช่องทางใหม่รายกรมธรรม์
  const handleSelectPaymentForPolicy = (policyNo, value) => {
    setSelections((s) => ({ ...s, [policyNo]: value }));
  };

  // ===== helper: มีตัวเลือกที่ใช้งานได้ไหม (ฝั่ง parent) =====
  const hasUsableOptionForPolicy = (policyNo) => {
    const p = dataPolicies.find((x) => x.policyNo === policyNo);
    if (!p) return false;
    const available = getAvailableOptions(p.policyPaymentMethod);
    const creditBlocked = !!creditMap[policyNo]; // true = ยังไม่ผูกบัตร → ปิด credit

    // มี option ไหนที่ไม่ถูก disable บ้าง?
    return available.some((opt) => {
      if (opt.value === "credit") return !creditBlocked;
      return true; // ตัวเลือกอื่นๆ ใช้ได้
    });
  };

  // ขั้นตอน
  const goBack = () => {
    if (step === 2) setStep(1);
    else if (step === 3) setStep(2);
    else if (step === 4) navigate("/personal");
    else navigate("/personal");
  };

  const handleReqOtp = async () => {
    const res = await requestOtpAPI("CHANGE_CHANNEL_PAY");
    res.status ? notifySuccess(res.meg) : notifyError(res.meg);
  };

  // const goNext = async () => {
  //   if (step === 1) {
  //     if (selectedPolicyNos.length === 0) {
  //       notifyError("กรุณาเลือกกรมธรรม์ก่อนดำเนินการ");
  //       return;
  //     }
  //     const missing = selectedPolicyNos.filter(pno => !selections[pno]);
  //     if (missing.length > 0) {
  //       notifyError("กรุณาเลือก 'ที่ต้องการเปลี่ยน' ให้ครบทุกกรมธรรม์ที่เลือก");
  //       return;
  //     }
  //     await handleReqOtp();
  //     setStep(2);
  //   } else if (step === 2) {
  //     setStep(3);
  //   } else if (step === 3) {
  //     await submitChangeChannel();
  //   }
  // };

  // ===== ปรับ goNext ให้เช็คเฉพาะกรมธรรม์ที่เลือกและ “ยังเปลี่ยนได้จริง” =====
  const goNext = async () => {
    if (step === 1) {
      // 1) ต้องมีเลือกอย่างน้อยหนึ่ง
      if (selectedPolicyNos.length === 0) {
        notifyError("กรุณาเลือกกรมธรรม์ก่อนดำเนินการ");
        return;
      }

      // 2) กรองให้เหลือเฉพาะที่ยังมีตัวเลือกใช้งานได้จริง
      const effectiveSelected = selectedPolicyNos.filter(
        hasUsableOptionForPolicy
      );

      // กันเคสผู้ใช้เคยติ๊กไว้ แล้วต่อมาถูกปิดสิทธิ์ → เอาออกจาก state ให้ตรงตามจริง
      if (effectiveSelected.length !== selectedPolicyNos.length) {
        setSelectedPolicyNos(effectiveSelected);
      }

      if (effectiveSelected.length === 0) {
        notifyError("ไม่พบกรมธรรม์ที่สามารถเปลี่ยนช่องทางการชำระได้");
        return;
      }

      // 3) เช็ค “ที่ต้องการเปลี่ยน” เฉพาะกรมธรรม์ที่ยังเปลี่ยนได้จริงเท่านั้น
      // const missing = effectiveSelected.filter((pno) => !selections[pno]);
      // if (missing.length > 0) {
      //   notifyError("กรุณาเลือก ช่องทางชำระที่ต้องการเปลี่ยน");
      //   return;
      // }
      setStep(2);
    } else if (step === 2) {
      await handleReqOtp();
      setStep(3);
    } else if (step === 3) {
      await submitChangeChannel();
    }
  };

  const submitChangeChannel = async () => {
    try {
      setLoading(true);
      const citizenId = decrypt(localStorage.getItem("customer_id"));

      // ส่งทีละกรมธรรม์ (ต้องการ parallel ให้ใช้ Promise.all ได้)
      for (const policyNo of selectedPolicyNos) {
        const policy = dataPolicies.find((p) => p.policyNo === policyNo);
        const selVal = selections[policyNo];
        const selLabel =
          allOptions.find((o) => o.value === selVal)?.label || "";

        const payload = {
          policyNo,
          currentPaymentChannel: policy?.policyPaymentMethod || "",
          requestPaymentChannel: selLabel,
          otp,
          citizenId,
          fullName,
        };

        const res = await updatePersonalChangePaymentChannelAPI(payload);

        // Check for error in payload
        if (res.success === false || res.payload?.error) {
          const errorMsg = res.payload?.error || res.message || "เกิดข้อผิดพลาดในการยืนยัน OTP";
          notifyError(errorMsg);
          setLoading(false);
          return; // หยุดการทำงานทันที
        }

        if (!res.success) {
          throw new Error("Update failed: " + policyNo);
        }
      }

      notifySuccess("บันทึกการเปลี่ยนแปลงสำเร็จ");
      setStep(4);
    } catch (err) {
      console.error(err);
      notifyError("เกิดข้อผิดพลาดในการเปลี่ยนแปลงช่องทางการชำระ");
    } finally {
      setLoading(false);
    }
  };

  // โหลดกรมธรรม์
  const getPolicyInformation = async () => {
    setLoadingContent(true);
    const result = await getPolicyInformationAPI(decrypt(insureIdCard));
    if (result.status) {
      const filtered = result.data.policies.filter(
        (p) => p.policyFullyPaidFlag !== "Y"
      );
      setDataPolicies(filtered);
    }
    setLoadingContent(false);
  };
  useEffect(() => {
    getPolicyInformation();
  }, []);

  useEffect(() => {
    setSelectedPolicyNos((arr) => arr.filter(hasUsableOptionForPolicy));
  }, [creditMap, dataPolicies]);

  // เลือกให้อัตโนมัติ โดยให้ความสำคัญ: credit > account > counter
const PRIORITY = ["credit", "account", "counter"];

const getAutoSelection = (policyNo) => {
  const p = dataPolicies.find((x) => x.policyNo === policyNo);
  if (!p) return undefined;

  const available = getAvailableOptions(p.policyPaymentMethod);
  const creditBlocked = !!creditMap[policyNo];

  // ตัด credit ออกถ้ายังไม่ผูกบัตร
  const usable = available
    .filter((o) => (o.value === "credit" ? !creditBlocked : true))
    .map((o) => o.value);

  // คืนค่าตัวเลือกแรกตามลำดับความสำคัญ
  return PRIORITY.find((v) => usable.includes(v));
};

useEffect(() => {
  if (!selectedPolicyNos.length) return;
  setSelections((prev) => {
    const next = { ...prev };
    let changed = false;
    for (const pno of selectedPolicyNos) {
      if (!next[pno]) {
        const autoVal = getAutoSelection(pno);
        if (autoVal) {
          next[pno] = autoVal;
          changed = true;
        }
      }
    }
    return changed ? next : prev;
  });
}, [selectedPolicyNos, creditMap, dataPolicies]);

  // หน้าสรุป step 2
  const SummaryCards = () => (
    <Card
      sx={{
        maxHeight: 510,
        overflowY: "auto",
        border: "1px solid rgba(255,94,67,0.3)",
        borderRadius: "12px",
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <AssignmentTurnedInRoundedIcon
            fontSize="large"
            style={{ color: "rgb(255, 94, 67)" }}
          />
          <Typography sx={{ fontSize: 20, ml: 1 }}>ยืนยันข้อมูล</Typography>
        </Box>

        {selectedPolicyNos.map((pno) => {
          const p = dataPolicies.find((x) => x.policyNo === pno);

          // ใช้ค่าที่มีใน selections ถ้าไม่มีให้คำนวณอัตโนมัติ
          const val = selections[pno] || getAutoSelection(pno);
          const label = allOptions.find((o) => o.value === val)?.label || "-";

          return (
            <Card
              key={pno}
              sx={{
                mb: 2,
                border: "1px solid rgba(255,94,67,0.3)",
                borderRadius: "12px",
              }}
            >
              <CardHeader
                title={
                  <Box>
                    <Typography sx={{ fontWeight: "bold" }}>
                      กรมธรรม์เลขที่ : {p?.policyNo}
                    </Typography>
                    <Typography sx={{ fontWeight: "bold" }}>
                      แบบประกัน : {p?.baseName}
                    </Typography>
                  </Box>
                }
                sx={{ backgroundColor: "rgba(255,94,67,0.3)" }}
              />
              <CardContent>
                <Typography sx={{ display: "flex", gap: 1 }}>
                  <Box sx={{ minWidth: 160, color: "#555" }}>
                    ช่องทางการชำระใหม่ :
                  </Box>
                  <Box sx={{ fontWeight: "bold" }}>{label}</Box>
                </Typography>
              </CardContent>
            </Card>
          );
        })}
      </CardContent>
    </Card>
  );

  return (
    <div>
      <ToastContainer />
      <Header_Home />
      <Header title="เปลี่ยนแปลงช่องทางการชำระ" />

      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (t) => t.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <div className="containers p-4">
        {LoadingContent ? (
          <Row className="card-custom3 d-flex">
            <Col className="mt-3">
              <Skeleton height={30} />
              <Skeleton count={8} />
            </Col>
          </Row>
        ) : step === 1 ? (
          <Box sx={{ p: 2 }}>
            <Typography sx={{ fontWeight: "bold", mb: 1 }}>
              เลือกกรมธรรม์
            </Typography>

            {dataPolicies?.length > 0 ? (
              <ScrollableChannelPay
                policies={dataPolicies}
                selectedPolicyNos={selectedPolicyNos}
                onTogglePolicy={handleTogglePolicy}
                selections={selections}
                onSelectPaymentForPolicy={handleSelectPaymentForPolicy}
                getAvailableOptions={getAvailableOptions}
                ensureCreditStatus={ensureCreditStatus}
                creditMap={creditMap}
              />
            ) : (
              <Paper
                elevation={0}
                sx={{
                  border: "1px solid rgba(255, 94, 67, 0.3)",
                  borderRadius: 2,
                  p: 3,
                  textAlign: "center",
                }}
              >
                <Typography sx={{ fontSize: 16, color: "#555" }}>
                  ไม่พบข้อมูลกรมธรรม์
                </Typography>
              </Paper>
            )}
          </Box>
        ) : step === 2 ? (
          <Box sx={{ p: 2 }}>
            <SummaryCards />
          </Box>
        ) : step === 3 ? (
          <Box sx={{ p: 1, margin: "auto" }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 2,
                display: "flex",
                alignItems: "center",
              }}
            >
              <VerifiedUserIcon
                sx={{ color: "#FF5E43", mr: 1, fontFamily: "Prompt-Thin" }}
              />
              ยืนยัน OTP
            </Typography>
            <Paper
              elevation={0}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 3,
                p: 3,
                mb: 3,
                textAlign: "center",
              }}
            >
              <Typography sx={{ mb: 2, textAlign: "left" }}>
                กรุณาใส่หมายเลข OTP 6 หลัก
                <br />
                ที่ส่งไปยังเบอร์มือถือท่าน
              </Typography>
              <input
                placeholder="OTP"
                maxLength={6}
                style={{
                  padding: "10px 20px",
                  borderRadius: "30px",
                  border: "1px solid #ccc",
                  fontSize: 18,
                  width: "100%",
                  outline: "none",
                  marginBottom: 8,
                }}
                value={otp}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setOtp(onlyNums);
                }}
              />
              <div style={{ width: "100%", marginTop: 10 }}>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }}
                >
                  ส่งรหัสผ่านไปที่หมายเลข{" "}
                  {localStorage.getItem("mobile_tel")
                    ? localStorage
                        .getItem("mobile_tel")
                        .replace(/(\d{3})(\d{4})(\d{3})/, "$1xxxx$3")
                    : ""}
                </div>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }}
                >
                  กรณีไม่ได้รับหรือเปลี่ยนหมายเลขโทรศัพท์มือถือ
                </div>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }}
                >
                  กรุณา
                  <span
                    onClick={() => setOpenContactModal(true)}
                    style={{
                      color: "#FF5E43",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    ติดต่อฝ่ายลูกค้าสัมพันธ์
                  </span>
                </div>
              </div>
              <Typography
                sx={{
                  color: "#f2654e",
                  fontSize: 14,
                  mt: 1,
                  cursor: "pointer",
                  textAlign: "left",
                }}
                onClick={handleReqOtp}
              >
                ส่งรหัส OTP อีกครั้ง?
              </Typography>
            </Paper>
          </Box>
        ) : (
          <Box
            sx={{
              border: "1px solid #ccc",
              borderRadius: "12px",
              p: 4,
              backgroundColor: "#fff",
              textAlign: "center",
            }}
          >
            <img
              src={successGif}
              alt="Success"
              style={{ width: "200px", marginBottom: "20px" }}
            />
            <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
              บริษัทฯ ได้รับคำขอเปลี่ยนแปลงการชำระเบี้ยเรียบร้อยแล้ว <br />
              มีผลงวดชำระในรอบถัดไป
            </Typography>
          </Box>
        )}

        <br />
        <section className="action-address">
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: "10vh" }}
          >
            <Grid item>
              <button
                onClick={goBack}
                className="btn-address-back p-2 bold"
                style={{ minWidth: 120 }}
              >
                {step === 4 ? "กลับสู่หน้าหลัก" : "ย้อนกลับ"}
              </button>
            </Grid>
            {step !== 4 && (
              <Grid item sx={{ ml: 1 }}>
                <button
                  onClick={goNext}
                  className="btn-address-next p-2 bold"
                  style={{ fontSize: 18, minWidth: 120,marginLeft: '12px' }}
                >
                  {step === 1 ? "ต่อไป" : step === 2 ? "ต่อไป" : "บันทึก"}
                </button>
              </Grid>
            )}
          </Grid>
        </section>
      </div>
      <ContactModal
        open={openContactModal}
        onClose={() => setOpenContactModal(false)}
      />
    </div>
  );
};

export default ChangeChannelPay;
